import { Store } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.MaterialCreated',
    callback: (material: KwixeoConstructions.Material): void => {
      store.dispatch('constructions/setMaterial', material)
    }
  },
  {
    name: '.MaterialUpdated',
    callback: (material: KwixeoConstructions.Material): void => {
      store.dispatch('constructions/setMaterial', material)
    }
  },
  {
    name: '.MaterialDeleted',
    callback: (material: KwixeoConstructions.Material): void => {
      store.dispatch('constructions/deleteMaterial', material)
    }
  },

  {
    name: '.TechnicalCreated',
    callback: (technical: KwixeoConstructions.Technical): void => {
      store.dispatch('constructions/setTechnical', technical)
    }
  },
  {
    name: '.TechnicalUpdated',
    callback: (technical: KwixeoConstructions.Technical): void => {
      store.dispatch('constructions/setTechnical', technical)
    }
  },
  {
    name: '.TechnicalDeleted',
    callback: (technical: KwixeoConstructions.Technical): void => {
      store.dispatch('constructions/deleteTechnical', technical)
    }
  },
  {
    name: '.ConstructionPdfGenerated',
    callback: (datas: KwixeoConstructions.PdfGenerated): void => {
      emitter.emit('constructionPdfGenerated', datas)
    }
  },
  {
    name: '.PlanificationPdfGenerated',
    callback: (datas: KwixeoConstructions.PdfGenerated): void => {
      emitter.emit('planificationPdfGenerated', datas)
    }
  }
])
